import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from '../components/AuthHeader';
import AuthFooter from '../components/AuthFooter';

const AuthLayout: React.FC = () => {
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [AuthFooterHeight, setAuthFooterHeight] = useState(0);

    useEffect(() => {
        const updateHeights = () => {
            requestAnimationFrame(() => {
                // Batch all DOM reads
                const navbar = document.querySelector('.adminuiux-header .navbar');
                const authFooter = document.querySelector('.adminuiux-footer');

                const navHeight = navbar?.clientHeight || 0;
                const footerHeight = authFooter?.clientHeight || 0;

                // Batch state updates
                setNavbarHeight(navHeight);
                setAuthFooterHeight(footerHeight);
            });
        };

        // Initial calculation
        updateHeights();

        // Recalculate on window resize
        window.addEventListener('resize', updateHeights);

        return () => {
            window.removeEventListener('resize', updateHeights);
        };
    }, []);

    return (
        <>
            {/* main content */}
            <div className="adminuiux-header inner-page z-index-5 position-relative">
                <AuthHeader />
            </div>
            <div className=" adminuiux-wrap">
                <main className="adminuiux-content" style={{ paddingTop: `${navbarHeight}px` }}>
                    <div className="container">
                        <div className="auth-wrapper">
                            <div className="row justify-content-center" style={{ height: `calc(100vh - (${navbarHeight}px + ${AuthFooterHeight}px))` } as React.CSSProperties}>
                                {/*Page body*/}
                                {/* login wrap */}
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </main>

            </div>

            <AuthFooter />
        </>
    );
};

export default AuthLayout;
